import { render, staticRenderFns } from "./OrganisationAdd.vue?vue&type=template&id=c07dfdfa&"
import script from "./OrganisationAdd.vue?vue&type=script&lang=ts&"
export * from "./OrganisationAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports